import { isWillChangeMotionValue as i } from "./atoms-v21205.js";
function o(e, a) {
  const l = e.getValue("willChange");
  if (i(l))
    return l.add(a);
}
export {
  o as addValueToWillChange
};
